import { navigate } from "gatsby"
import {Modal} from "antd";
import {AlertIcon} from "../components/icons";
import React from "react";

const UNAUTHORIZED = 401
const NOT_FOUND = 404

const closeLiff = () => {
  const { liff = {} } = window
  if (liff.closeWindow) {
    liff.closeWindow()
  }
}
export default (error, t, type = 'default', options = {}) => {
  if (error && error.response && error.response.status === UNAUTHORIZED) {  
    const { responseCode, responseMessage } = error.response.data.meta
    const message = responseCode && responseMessage ? `${responseCode} ${responseMessage}` : t('sorry_description')
    Modal.error({
      icon: <div className={'modal-timeout-icon'}><AlertIcon/></div>,
      width: 300,
      content: <div className={'modal-custom-body-timeout'}>
        <div className={'modal-custom-title'}>
          {t('sorry_title')}
        </div>
        <div>{message}</div>
      </div>,
      onOk() {
        closeLiff()
      }
    })
  } else if ((error && error.code && error.code === 'ECONNABORTED') || (error && error.message && error.message === 'Network Error')) {
    Modal.error({
      icon: <div className={'modal-timeout-icon'}><AlertIcon/></div>,
      width: 300,
      content: <div className={'modal-custom-body-timeout'}>
        <div className={'modal-custom-title'}>
          { t('sorry_title')}
        </div>
        <div>{t('sorry_description')}</div>
      </div>,
      onOk() {
        navigate('/', { state: { exception: true } })
      }
    })
  } else if (error && error.response && error.response.status === NOT_FOUND) {
    Modal.error({
      icon: <div className={'modal-timeout-icon'}><AlertIcon/></div>,
      width: 300,
      content: <div className={'modal-custom-body-timeout'}>
        <div className={'modal-custom-title'}>
          { t('sorry_title')}
        </div>
        <div>{t('sorry_description')}</div>
      </div>,
      onOk() {}
    })
  } else {
    try{

      let message = t('sorry_description')
      if(error && error.response && error.response.data && error.response.data.meta) {
        const { responseCode, responseMessage } = error.response.data.meta
        message = responseCode && responseMessage ? `${responseMessage}` : t('sorry_description')
      }
  
      switch (type) {
        case 'INIT': {
          Modal.error({
            icon: <div className={'modal-timeout-icon'}><AlertIcon/></div>,
            width: 300,
            content: <div className={'modal-custom-body-timeout'}>
              <div className={'modal-custom-title'}>
                {t('sorry_title')}
              </div>
              <div>{message}</div>
            </div>,
            onOk() {
              closeLiff()
            }
          })
          break
        }
        case 'CREATE_BOOKING': {
          Modal.error({
            icon: <div className={'modal-timeout-icon'}><AlertIcon/></div>,
            width: 300,
            content: <div className={'modal-custom-body-timeout'}>
              <div className={'modal-custom-title'}>
                {t('sorry_title')}
              </div>
              <div>{message}</div>
            </div>,
            onOk() {
              const windowGlobal = typeof window !== 'undefined' && window
  
              const len = windowGlobal.storageHistory.length
              windowGlobal.storageHistory[len - 1] = {
                ...windowGlobal.storageHistory[len - 1],
                error: true
              }
              navigate('/privilege-detail/', { state: { privilegeCode: options.privilegeCode, exception: true } })
            }
          })
          break
        }
        case 'UPDATE_BOOKING': {
          Modal.error({
            icon: <div className={'modal-timeout-icon'}><AlertIcon/></div>,
            width: 300,
            content: <div className={'modal-custom-body-timeout'}>
              <div className={'modal-custom-title'}>
                {t('sorry_title')}
              </div>
              <div>{message}</div>
            </div>,
            onOk() {
              const windowGlobal = typeof window !== 'undefined' && window
  
              const len = windowGlobal.storageHistory.length
              windowGlobal.storageHistory[len - 1] = {
                ...windowGlobal.storageHistory[len - 1],
                error: true
              }
  
              navigate('/booking/details', { state: { exception: true } })
            }
          })
          break
        }
        case 'REDEEM': {
          Modal.error({
            icon: <div className={'modal-timeout-icon'}><AlertIcon/></div>,
            width: 300,
            content: <div className={'modal-custom-body-timeout'}>
              <div className={'modal-custom-title'}>
                {t('sorry_title')}
              </div>
              <div>{message}</div>
            </div>,
            onOk() {
              const windowGlobal = typeof window !== 'undefined' && window
  
              const len = windowGlobal.storageHistory.length
              windowGlobal.storageHistory[len - 1] = {
                ...windowGlobal.storageHistory[len - 1],
                error: true
              }
  
              navigate('/privilege-detail', { state: { privilegeCode: options.privilegeCode, exception: true } })
            }
          })
          break
        }
        default: {
          Modal.error({
            icon: <div className={'modal-timeout-icon'}><AlertIcon/></div>,
            width: 300,
            content: <div className={'modal-custom-body-timeout'}>
              <div className={'modal-custom-title'}>
                {t('sorry_title')}
              </div>
              <div>{message}</div>
            </div>,
            onOk() {
              navigate('/', { state: { exception: true } })
            }
          })
          break
        }
      }
    } catch (err) {
      // console.log(err)
    }
   
  }
}
